import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface StepperProps {
  steps: string[];
  currentStep: number;
}

export const Stepper = ({ steps, currentStep }: StepperProps) => {
  return (
    <div className="w-full py-4 ">
      <div className="flex items-center justify-start md:justify-center min-w-max px-4">
        {steps.map((step, index) => (
          <div key={index} className="flex items-center">
            <div className="relative flex flex-col items-center">
              <div
                className={cn(
                  "w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center border-2 transition-all duration-200",
                  currentStep > index
                    ? "bg-primary border-primary text-white"
                    : currentStep === index
                    ? "border-primary text-primary"
                    : "border-gray-300 text-gray-300"
                )}
              >
                {currentStep > index ? (
                  <Check className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />
                ) : (
                  <span className="text-xs sm:text-sm md:text-base">{index + 1}</span>
                )}
              </div>
              <span
                className={cn(
                  "absolute -bottom-6 text-[8px] sm:text-[10px] md:text-xs w-max text-center transition-colors duration-200",
                  currentStep >= index ? "text-primary" : "text-gray-300"
                )}
              >
                {step}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={cn(
                  "w-8 sm:w-12 md:w-20 h-[2px] mx-1 transition-colors duration-200",
                  currentStep > index ? "bg-primary" : "bg-gray-300"
                )}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};